<template>
  <div class="mobile-header-bar">
    <div class="logo" @click="() => $router.push({ name: 'mhome' })">
      <img src="/imgs/logo.png" alt=""/>
    </div>
    <div class="function-area">
      <div class="dropdown">
        <button class="dropdown-button" @click="toggleDropdown">
          {{ getNameByValue(language) }}
          <span class="caret"><icon class="el-icon-arrow-down"></icon></span>
        </button>
        <div class="dropdown-content" v-if="showDropdown">
          <div
              v-for="(lang, index) in languages"
              :key="index"
              @click="changeLangEvent(lang.value)"
              class="dropdown-item"
          >
            {{ lang.name }}
          </div>
        </div>
      </div>
      <div class="menu-btn" @click="drawer = true"></div>
    </div>
    <el-drawer :visible.sync="drawer" @close="drawerClose">
      <div>
        <div>
          <ul class="menu-box">
            <li :key="el.name" v-for="el in $t('topMenu')" class="menu-group">
              <div class="menu-item" @click="handleMenuClick(el)">
                <span class="menu-item-title">{{ el.name }}</span>
                <i class="el-icon-arrow-right" v-if="el.childList && el.childList.length"></i>
              </div>
              <ul v-if="el.childList && el.childList.length"
                  v-show="activeSubMenu === el"
                  class="submenu">
                <li
                    v-for="child in el.childList"
                    :key="child.name"
                    @click.stop="handleMenuClick(child)"
                    class="submenu-item"
                >{{ child.name }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "MobileHeaderBar",
  data() {
    return {
      drawer: false,
      activeSubMenu: null,
      showDropdown: false,
      language: localStorage.getItem("locale") || "en",
      languages: [
        {
          name: 'English',
          value: 'en'
        },
        {
          name: '简体中文',
          value: 'cn'
        }
      ]
    };
  },
  methods: {
    toggleSubMenu(el) {
      this.activeSubMenu = this.activeSubMenu === el ? null : el;
    },
    handleMenuClick(item) {
      if (item.url) {
        // 如果有URL则跳转
        this.goThere(item.url);
      } else if (item.anchor) {
        // 如果有锚点则滚动
        this.scrollToAnchor(item.anchor);
      } else if (item.childList && item.childList.length) {
        // 如果有子菜单则展开/收起
        this.toggleSubMenu(item);
      }
    },
    scrollToAnchor(anchorId) {
      this.drawer = false;
      this.activeSubMenu = null;

      this.$nextTick(() => {
        const targetElement = document.getElementById(anchorId);
        if (targetElement) {
          const headerOffset = 60; // 移动端header高度
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    },
    goThere(url) {
      this.drawer = false;
      this.activeSubMenu = null;
      this.$router.push({
        name: "m" + url,
      });
    },
    drawerClose() {
      this.drawer = false;
      this.activeSubMenu = null;
    },
    getNameByValue(value) {
      const lang = this.languages.find(lang => lang.value === value);
      return lang ? lang.name : '';
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    changeLangEvent(value){
      localStorage.setItem("locale", value);
      this.$i18n.locale = localStorage.getItem("locale");
      this.language = value;
      location.reload();
      this.showDropdown = false;
    }
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-drawer.rtl {
  width: 100% !important;
  margin-bottom: 10px;
}

::v-deep .el-drawer__header {
  margin-bottom: 15px;
}

::v-deep .el-drawer__close-btn {
  font-size: 24px;
}

.mobile-header-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  width: 100%;
  height: 2.222rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,.1);
  padding: 0 3%;
  margin: 0;

  .logo {
    display: flex;
    align-items: center;
    height: 100%;
    flex-shrink: 0;

    img {
      width: auto;
      height: 50%;
      vertical-align: middle;
    }
  }

  .function-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    flex-shrink: 0;
  }

  .menu-btn {
    width: 1rem;
    height: 1rem;
    background: url(../../../../public/imgs/menu-icon.png) center no-repeat;
    background-size: 100% 100%;
    flex-shrink: 0;
  }
}

.menu-box {
  padding: 0 1rem;

  .menu-group {
    display: block;
    margin-bottom: 0.4rem;
  }

  .menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.667rem;
    padding: 0.4rem 0;
    color: #0c0c0c;
    cursor: pointer;
  }

  .submenu {
    list-style-type: none;
    margin: 0;
    padding-left: 1rem;
    margin-top: 0.4rem;
    z-index: 10;
    position: relative;

    .submenu-item {
      font-size: 0.667rem;
      padding: 0.4rem 0;
      color: #0c0c0c;
      cursor: pointer;
    }
  }
}

.dropdown {
  position: relative;
  display: inline-block;

  .dropdown-button {
    border: none;
    background-color: transparent;
    padding: 0.2rem 0.4rem;
    font-size: 0.55rem;
    cursor: pointer;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: none;
  }

  .dropdown-button:focus {
    outline: none;
  }

  .caret {
    margin-left: 0.2rem;
    font-size: 0.5rem;
  }

  .dropdown-content {
    position: absolute;
    left: 0;
    top: 100%;
    display: block;
    background-color: #fff;
    min-width: 4rem;
    box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.15);
    border: 1px solid #ddd;
    border-top: none;
    max-height: 120px;
    overflow-y: auto;
    z-index: 9999;
    border-radius: 3px;
  }

  .dropdown-item {
    padding: 4px 8px;
    cursor: pointer;
    font-size: 0.55rem;
  }

  .dropdown-item:hover {
    background-color: #f1f1f1;
  }
}
</style>
